import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Toaster } from '../components/ui/sonner';
import MigrationPrompt from './MigrationPrompt';

export const Layout = () => (
  <div className="flex min-h-screen bg-[#F6F6F4]" data-testid="app-layout">
    <Sidebar />
    <main className="flex-1 min-w-0 overflow-x-auto">
      <div className="px-10 py-10 max-w-[1400px]">
        <Outlet />
      </div>
    </main>
    <MigrationPrompt />
    <Toaster position="bottom-right" richColors />
  </div>
);

export default Layout;
